import { Card } from "../../components/Card";
import { PROMO_REVIEW_MAP } from "./constants";

export function PromotionsReviewsIntroCard() {
  return (
    <Card
      variant="light"
      className="promotionsPinnedIntro"
      title="Отзывы на картах"
      subtitle={`Две одноразовые акции: по ${PROMO_REVIEW_MAP} бонусов за отзывов в Яндекс.Картах и в 2ГИС (нажми кнопку — откроется сайт, оставь отзыв).`}
    >
      <p className="errorMessage">
        Бонус за отзыв в Яндекс.Картах и в 2ГИС начисляется через 24 часа после выполнения шага.
      </p>
    </Card>
  );
}
